import React from 'react'
import { Alert } from 'antd'

export function TwoStepFormWarning() {
    return (
        <Alert
            className="safari-2step"
            type="warning"
            showIcon={true}
            message=""
            description={
                <span>
                    At this time only Web Push prompts may be created. Custom Native prompt creation is not supported.
                    The default Native prompts can be viewed and enabled / disabled in their respective lists.
                </span>
            }
        />
    )
}
